import React, { useEffect } from "react";
import "./Components/assets/css/global.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Components/layout";
import Nav from "./Components/Common/Nav";
import Loader from "./Components/Loader";
import { useTheme } from "./context/ThemeContext";
import { useSocket } from "./context/SocketContext";

const App = () => {
  const { theme, loading, userId } = useTheme();

  // const { subscribe, connected } = useSocket();

  // useEffect(() => {
  //   if (!connected) return;

  //   const unsubscribe = subscribe(
  //     `/topic/connect/${userId}`,
  //     (data) => {
  //       console.log("📩 Socket message:", data);
  //     },
  //   );

  //   return unsubscribe;
  // }, [connected, userId]);



  if (loading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <Nav theme={theme} />
      <Routes>
        <Route path="/*" element={<Layout theme={theme} />} />
        {/* <Route path="/:comSlug/*" element={<Layout theme={theme} />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
